module.exports = __webpack_public_path__ + "img/add.557fabdd.svg";